import styles from './FieldError.module.css';

interface FieldErrorProps {
  /** Must match the input's aria-describedby, or a screen reader never reads it. */
  id: string;
  /** Absent means the field is fine and nothing renders. */
  message?: string;
}

/**
 * The validation message under a single input.
 *
 * `role="alert"` rather than a plain paragraph: these appear in response to a
 * submit the person just made, and a message that only exists visually is
 * invisible to anyone using a screen reader — who has just been told nothing
 * happened.
 *
 * Renders nothing at all when there is no message, so the layout does not
 * reserve a gap under every field for an error most of them will never have.
 */
export function FieldError({ id, message }: FieldErrorProps) {
  if (!message) return null;
  return (
    <p id={id} className={styles.fieldError} role="alert">
      {message}
    </p>
  );
}
